import Clarity from '@microsoft/clarity'
import * as Sentry from '@sentry/react'
import { API_ROOT } from 'Config'
import {
  ALL_GIFT_CARDS,
  CUSTOMERPROFILEDETAILS,
  EMERGENCYCONTACTSLIST,
  GET_PROFILE_IMAGE,
  KENKO_PAYMENT_METHODS,
  KENKO_PAYMENT_METHODS_LOADING,
  LOGIN,
  LOGOUT,
  MEMBERSHIP,
  CANCELLATION_REASONS,
  PAST_BOOKING_DETAILS,
  PAYMENTDETAILS,
  PAYMENTMODES,
  PROFILE_IMAGE_ERROR,
  RELATEDCONTACTSLIST,
  SAVEDCARDS,
  SETURLPREFIX,
  SIGNUP,
  UPCOMING_BOOKING_DETAILS,
  UPDATE_USER_PROFILE
} from 'Constants'
import { CONFIRM, GENERATE, VERIFY } from 'Constants/index'
import LogRocket from 'logrocket'
import { getUrlParams } from '../components/Common'
import {
  BOOKING_TYPES,
  INSTALLMENTS,
  SAVED_PAYMENT_METHODS
} from '../constants'
import { store } from '../store.index'
import { dataLayerPush, dataURLtoFile, trackEvent } from '../utils/helper'
import {
  bookee_completed_registration,
  eventCategoryOptions
} from '../constants/events'
import { client } from './client'

const axios = client()

let axiosConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('customerkey')
  }
}

const authHeaders = () => {
  const customerKey = localStorage.getItem('customerkey')
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(customerKey ? { Authorization: 'Bearer ' + customerKey } : {})
  }
}

export function loginUser(postData) {
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  delete axiosConfig.headers.Authorization

  let requestUrl = `${API_ROOT}/api/embed/auth/login/`
  let request = axios.post(requestUrl, postData, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        if (data && data.status == 'success') {
          let customerKey = data.data.access_token
          localStorage.setItem('customerkey', customerKey)
          localStorage.setItem('contact', JSON.stringify(data.data.contact))
          let clientSettings = localStorage.getItem('clientSettings')
          clientSettings = JSON.parse(clientSettings)
          Clarity.setTag('email', data.data.contact.email)
          Clarity.setTag('first_name', data.data.contact.first_name)
          Clarity.setTag('last_name', data.data.contact.last_name)

          if (clientSettings) {
            Clarity.setTag('business', clientSettings?.name)
          }
          //Clear out any previously stored user emails
          Sentry.getCurrentScope().setUser({
            email: null
          })
          //Add user email to sentry scope
          Sentry.getCurrentScope().setUser({
            email: data.data.contact.email
          })
          // Add user email to logrocket recordings
          LogRocket.identify(data.data.contact.email)

          dispatch(getUserProfile())
        }
        dispatch({ type: LOGIN, payload: data })
      })
      .catch(err => {
        dispatch({ type: LOGIN, payload: err.response?.data })
      })
  }
}

export function sendMagicLink(email, redirectUrl) {
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  delete axiosConfig.headers.Authorization

  let requestUrl = `${API_ROOT}/api/embed/auth/magic-link/send`
  const payload = { email }
  if (redirectUrl) {
    payload.ref = redirectUrl
  }
  let request = axios.post(requestUrl, payload, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: LOGIN, payload: data })
      })
      .catch(err => {
        const data = err.response?.data || {
          status: 'error',
          message: 'Failed to send magic link'
        }
        dispatch({ type: LOGIN, payload: data })
      })
  }
}

export function getError401() {
  const requestUrl = `${API_ROOT}/api/embed/401`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: '401ERROR', payload: {} })
      })
      .catch(err => {
        dispatch({ type: '401ERROR', payload: {} })
      })
  }
}
export function logoutUser() {
  const awsWafToken = localStorage.getItem('aws-waf-token')
  const displayTimezone = localStorage.getItem('bookee_display_tz')
  localStorage.clear()
  if (awsWafToken) {
    localStorage.setItem('aws-waf-token', awsWafToken)
  }
  if (displayTimezone === 'local' || displayTimezone === 'studio') {
    localStorage.setItem('bookee_display_tz', displayTimezone)
  }
  Sentry.getCurrentScope().setUser({
    email: null
  })
  return dispatch => {
    dispatch({ type: LOGOUT, payload: null })
  }
}

export function setUrlPrefix(prefix) {
  localStorage.setItem('url_prefix', prefix)
  return dispatch => {
    dispatch({ type: SETURLPREFIX, payload: prefix })
  }
}

export function signupUser(Data, { registrationSource } = {}) {
  const postData = Data
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  return async (dispatch, getState) => {
    let requestUrl = `${API_ROOT}/api/embed/auth/signup`
    let request = axios.post(requestUrl, postData, axiosConfig)
    request
      .then(({ data }) => {
        if (
          data &&
          data.status === 'success' &&
          !(data.data && 'exists' in data.data)
        ) {
          let customerKey = data.data.access_token
          localStorage.setItem('customerkey', customerKey)
          localStorage.setItem('contact', JSON.stringify(data.data.contact))
          //Clear out any previously stored user emails
          Sentry.getCurrentScope().setUser({
            email: null
          })
          //Add user email to sentry scope
          Sentry.getCurrentScope().setUser({
            email: data.data.contact.email
          })
          // Add user email to logrocket recordings
          LogRocket.identify(data.data.contact.email)
          trackEvent({
            category: eventCategoryOptions.completeRegistration,
            action: 'Registers an account with your Studio',
            label: bookee_completed_registration
          })
          dataLayerPush({
            event: 'sign_up',
            registration_status: 'new',
            registration_source: registrationSource || 'other'
          })
        }
        dispatch({ type: SIGNUP, payload: data })
      })
      .catch(err => {
        dispatch({
          type: SIGNUP,
          payload: err.response?.data ?? 'Signup failed'
        })
      })
  }
}

export const getCustomSignupData = () => {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  const requestUrl = `${API_ROOT}/api/embed/custom-signup`
  return axios.get(requestUrl, axiosConfig)
}

export function savePassword(postdata) {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    region_id: localStorage.getItem('region_id')
  }
  let requestUrl = `${API_ROOT}/api/embed/auth/password/reset`
  let request = axios.post(requestUrl, postdata, axiosConfig)
  return function(dispatch) {
    return request
      .then(({ data }) => {
        dispatch({ type: CONFIRM, payload: data })
      })
      .catch(err => {
        dispatch({ type: CONFIRM, payload: err.response?.data })
      })
  }
}

export function changePassword(postdata) {
  const customerKey = localStorage.getItem('customerkey')
  axiosConfig.headers.Authorization = 'Bearer ' + customerKey
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    region_id: localStorage.getItem('region_id'),
    center_id: localStorage.getItem('center_id')
  }
  const requestUrl = `${API_ROOT}/api/embed/auth/password/change`
  return function() {
    return axios
      .post(requestUrl, postdata, axiosConfig)
      .then(({ data }) => data)
      .catch(
        err =>
          err.response?.data || {
            status: 'error',
            message: 'Unable to change password'
          }
      )
  }
}

export function generateOtp(postdata) {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    region_id: localStorage.getItem('region_id'),
    center_id: localStorage.getItem('center_id')
  }
  const payload = {
    ...postdata,
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: localStorage.getItem('center_id')
  }
  let requestUrl = `${API_ROOT}/api/embed/auth/password/send/otp`
  let request = axios.post(requestUrl, payload, axiosConfig)
  return function(dispatch) {
    return request
      .then(({ data }) => {
        dispatch({ type: GENERATE, payload: data })
        return data
      })
      .catch(err => {
        dispatch({ type: GENERATE, payload: err.response?.data })
        return err.response?.data
      })
  }
}

export function verifyOtp(postdata) {
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  let requestUrl = `${API_ROOT}/api/embed/auth/password/otp/verify`
  let request = axios.post(requestUrl, postdata, axiosConfig)
  return function(dispatch) {
    return request
      .then(({ data }) => {
        dispatch({ type: VERIFY, payload: data })
      })
      .catch(err => {
        dispatch({ type: VERIFY, payload: err.response?.data })
      })
  }
}

export const checkEmail = email => {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    email: email
  }
  const requestUrl = `${API_ROOT}/api/embed/auth/email-exists`
  return axios.get(requestUrl, axiosConfig)
}

export function getUserProfile() {
  const customerKey = localStorage.getItem('customerkey')

  axiosConfig.headers.Authorization = 'Bearer ' + customerKey
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile`

  let request = null

  if (customerKey) request = axios.get(requestUrl, axiosConfig)

  return dispatch => {
    if (!request) return null

    request
      .then(({ data }) => {
        dispatch({ type: CUSTOMERPROFILEDETAILS, payload: data })
        // Keep localStorage contact phone/prefix in sync for reset-password SMS prefill
        try {
          const profile = data?.data || data
          if (profile?.phone || profile?.phone_prefix || profile?.email) {
            const existing = JSON.parse(localStorage.getItem('contact') || '{}')
            localStorage.setItem(
              'contact',
              JSON.stringify({
                ...existing,
                email: profile.email ?? existing.email,
                phone: profile.phone ?? existing.phone,
                phone_prefix: profile.phone_prefix ?? existing.phone_prefix
              })
            )
          }
        } catch (_) {
          // ignore storage errors
        }
      })
      .catch(err => {
        dispatch({ type: CUSTOMERPROFILEDETAILS, payload: err })
      })
  }
}

export function clearCustomerProfile() {
  return dispatch => {
    dispatch({ type: CUSTOMERPROFILEDETAILS, payload: null })
  }
}

export function fetchProfileBookings({
  pageNumber = 1,
  bookingType = BOOKING_TYPES.upcoming,
  serviceId = null,
  perPage = null
} = {}) {
  const params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    page: pageNumber,
    type: bookingType
  }
  if (serviceId != null) params.service_id = serviceId
  if (perPage != null) params.per_page = perPage

  return axios.get(`${API_ROOT}/api/embed/profile/bookings`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('customerkey')
    },
    params
  })
}

export function getAllBookings({
  pageNumber = 1,
  bookingType = BOOKING_TYPES.upcoming,
  serviceId = null
}) {
  const request = fetchProfileBookings({
    pageNumber,
    bookingType,
    serviceId
  })
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({
          type:
            bookingType === BOOKING_TYPES.past
              ? PAST_BOOKING_DETAILS
              : UPCOMING_BOOKING_DETAILS,
          payload: data
        })
      })
      .catch(err => {
        dispatch({
          type:
            bookingType === BOOKING_TYPES.past
              ? PAST_BOOKING_DETAILS
              : UPCOMING_BOOKING_DETAILS,
          payload: err
        })
      })
  }
}

export function getAllMemberships() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/memberships`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({ type: MEMBERSHIP, payload: data })
        return data
      })
      .catch(err => {
        dispatch({ type: MEMBERSHIP, payload: err })
      })
  }
}

export function getCancellationReasons() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    center_id: localStorage.getItem('selected_center_id'),
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/memberships/cancellation-reasons`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({ type: CANCELLATION_REASONS, payload: data })
      })
      .catch(err => {
        console.error('Failed to fetch cancellation reasons:', err)
        dispatch({
          type: CANCELLATION_REASONS,
          payload: { status: 'error', data: null }
        })
      })
  }
}

export function getAllPayments() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/payments`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({ type: PAYMENTDETAILS, payload: data })
        return data
      })
      .catch(err => {
        dispatch({ type: PAYMENTDETAILS, payload: err })
      })
  }
}

export function getAllInstallments() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    status: 'pending'
  }

  let requestUrl = `${API_ROOT}/api/embed/payment_plan/installments`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({ type: INSTALLMENTS, payload: data })
        return data
      })
      .catch(err => {
        dispatch({ type: INSTALLMENTS, payload: err })
      })
  }
}

export function addRelatedContact(postdata) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/related`
  let request = axios.post(requestUrl, postdata, axiosConfig)
  return request
}

export function getRelatedContactsList() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  let requestUrl = `${API_ROOT}/api/embed/profile/related`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({
          type: RELATEDCONTACTSLIST,
          payload: data.data.related_contacts
        })
        return data
      })
      .catch(err => {
        dispatch({ type: RELATEDCONTACTSLIST, payload: err })
      })
  }
}

export function getEmergencyContactsList() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  let requestUrl = `${API_ROOT}/api/embed/profile/emergency`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({
          type: EMERGENCYCONTACTSLIST,
          payload: data.data.emergency_contacts
        })
        return data
      })
      .catch(err => {
        dispatch({ type: EMERGENCYCONTACTSLIST, payload: err })
      })
  }
}

export function cancelBookings(postdata) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  let requestUrl = `${API_ROOT}/api/embed/events/${postdata.event_id}/bookings/${postdata.booking_id}`
  const axiosConfigObject = { headers: axiosConfig.headers }
  axiosConfigObject.params = {
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  return axios.delete(requestUrl, axiosConfigObject)
}

export const cancelBooking = async (postdata, ids) => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  let requestUrl = `${API_ROOT}/api/embed/events/${postdata.event_id}/bookings/${postdata.booking_id}`
  const axiosConfigObject = { headers: axiosConfig.headers }
  axiosConfigObject.params = {
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const obj = {
    center_contact_ids: []
  }

  if (ids.length > 0) {
    obj.center_contact_ids = ids
  }

  try {
    const response = axios.post(requestUrl, obj, axiosConfigObject)
    return response
  } catch (e) {
    console.log(e)
  }
}

export const addBookingGuests = async ({
  event_id,
  booking_id,
  friend_contacts
}) => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  const requestUrl = `${API_ROOT}/api/embed/events/${event_id}/bookings/${booking_id}/guests`
  const axiosConfigObject = { headers: axiosConfig.headers }
  axiosConfigObject.params = {
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  return axios.post(requestUrl, { friend_contacts }, axiosConfigObject)
}

export function getPaymentMode(centerId) {
  const customerKey = localStorage.getItem('customerkey')
  if (customerKey) {
    axiosConfig.headers.Authorization = 'Bearer ' + customerKey
  } else {
    delete axiosConfig.headers.Authorization
  }
  let requestUrl = `${API_ROOT}/api/embed/gateways`
  const regionId = localStorage.getItem('region_id')

  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: centerId ?? localStorage.getItem('selected_center_id')
  }

  let request = null

  if (regionId) request = axios.get(requestUrl, axiosConfig)

  return dispatch => {
    if (request)
      request
        .then(({ data }) => {
          dispatch({ type: PAYMENTMODES, payload: data.data.payment_methods })
        })
        .catch(err => {
          dispatch({ type: PAYMENTMODES, payload: err.response?.data })
        })
  }
}

export function getKenkoPaymentMethods(centerId) {
  const requestUrl = `${API_ROOT}/api/embed/available/payment-methods`

  const requestConfig = {
    headers: authHeaders(),
    params: {
      region_id: localStorage.getItem('region_id'),
      url_prefix: store.getState().accountreducer.urlPrefix,
      center_id: centerId ?? localStorage.getItem('selected_center_id')
    }
  }

  return dispatch => {
    dispatch({ type: KENKO_PAYMENT_METHODS_LOADING, payload: true })
    axios
      .get(requestUrl, requestConfig)
      .then(({ data }) => {
        dispatch({ type: KENKO_PAYMENT_METHODS, payload: data.data || [] })
      })
      .catch(err => {
        console.error('Failed to fetch Kenko payment methods:', err)
        dispatch({ type: KENKO_PAYMENT_METHODS, payload: [] })
      })
      .finally(() => {
        dispatch({ type: KENKO_PAYMENT_METHODS_LOADING, payload: false })
      })
  }
}

export function getAllCard(rid = false, cid = false) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')

  axiosConfig.params = {
    region_id: rid || localStorage.getItem('region_id'),
    center_id:
      cid ||
      localStorage.getItem('selected_center_id') ||
      localStorage.getItem('center_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/sources`
  let request = axios.get(requestUrl, axiosConfig)
  return dispatch => {
    return request
      .then(({ data }) => {
        dispatch({ type: SAVEDCARDS, payload: data.data })
        dispatch({ type: SAVED_PAYMENT_METHODS, payload: data.data })
        return data
      })
      .catch(err => {
        dispatch({
          type: SAVEDCARDS,
          payload: err.response?.data ?? err
        })
        dispatch({
          type: SAVED_PAYMENT_METHODS,
          payload: err.response?.data ?? err
        })
      })
  }
}

export const setDefaultCard = id => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')

  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: localStorage.getItem('selected_center_id')
  }
  const requestUrl = `${API_ROOT}/api/embed/profile/sources/${id}`

  try {
    const request = axios.put(requestUrl, {}, axiosConfig)
    return request
  } catch (e) {
    console.log(e)
  }
}

export function deletePaymentMethod(id) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  let requestUrl = `${API_ROOT}/api/embed/profile/sources`
  const axiosConfigObject = {
    headers: axiosConfig.headers,
    data: { source: id },
    params: {
      url_prefix: store.getState().accountreducer.urlPrefix,
      center_id: localStorage.getItem('selected_center_id'),
      region_id: localStorage.getItem('region_id')
    }
  }

  try {
    let request = axios.delete(requestUrl, axiosConfigObject)
    return request
  } catch (e) {
    console.log(e)
  }
}

export function getSetupIntent() {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')

  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: localStorage.getItem('selected_center_id')
  }

  let requestUrl = `${API_ROOT}/api/embed/profile/create-setup-intent`

  try {
    let request = axios.post(requestUrl, {}, axiosConfig)
    return request
  } catch (e) {
    console.log(e)
    throw e
  }
}

export function getAllGiftCards(
  center_id = localStorage.getItem('selected_center_id')
) {
  const urlPrefix = getUrlParams()
  if (!localStorage.getItem('region_id') || !urlPrefix) {
    return dispatch => {
      dispatch({ type: ALL_GIFT_CARDS, payload: null })
      return Promise.resolve(null)
    }
  }

  let planrequestUrl = `${API_ROOT}/api/embed/profile/gift_cards?center_id=${center_id}&url_prefix=${localStorage.getItem(
    'url_prefix'
  )}&past=true`

  let request = axios.all([axios.get(planrequestUrl, axiosConfig)])

  return dispatch => {
    return request
      .then(res => {
        dispatch({
          type: ALL_GIFT_CARDS,
          payload: res[0].data.data
        })
        return res[0].data.data
      })
      .catch(err => {
        console.log(err)
        dispatch({ type: ALL_GIFT_CARDS, payload: err })
      })
  }
}

export function linkProfile() {
  const store_state = store.getState()
  let center_id =
    localStorage.getItem('selected_center_id') ||
    localStorage.getItem('center_id')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store_state.accountreducer.urlPrefix,
    center_id: center_id
  }
  if (store_state.isLoggedReducer) {
    // Rehydrate authorization
    axiosConfig.headers.Authorization =
      'Bearer ' + localStorage.getItem('customerkey')
    let requestUrl = `${API_ROOT}/api/embed/profile/link`
    let request = axios.post(
      requestUrl,
      { check_center_id: center_id },
      axiosConfig
    )
    return request
  } else {
    return ''
  }
}

export function sendInvitation(data) {
  let center_id =
    localStorage.getItem('selected_center_id') ||
    localStorage.getItem('center_id')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: center_id
  }
  let requestUrl = `${API_ROOT}/api/embed/profile/invite`
  let request = axios.post(requestUrl, data, axiosConfig)
  return request
}

export function uploadProfileImage(imageUri) {
  return async dispatch => {
    axiosConfig.headers.Authorization =
      'Bearer ' + localStorage.getItem('customerkey')
    const imageItem = await dataURLtoFile(imageUri, 'profileImage.png')
    const fd = new FormData()
    fd.append('image', imageItem)
    fd.append('type', 'contacts/profile')

    axiosConfig.params = {
      region_id: localStorage.getItem('region_id'),
      url_prefix: store.getState().accountreducer.urlPrefix
    }
    const requestUrl = `${API_ROOT}/api/embed/profile/image`
    const request = axios.post(requestUrl, fd, axiosConfig)
    request
      .then(({ data }) => {
        dispatch({ type: GET_PROFILE_IMAGE, payload: data.url })
      })
      .catch(err => {
        dispatch({ type: PROFILE_IMAGE_ERROR, payload: err?.response?.data })
      })
  }
}

export function updateProfile(data) {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix,
    center_id: localStorage.getItem('selected_center_id')
  }
  const requestUrl = `${API_ROOT}/api/embed/profile`
  const request = axios.put(requestUrl, data, axiosConfig)
  return dispatch => {
    request
      .then(({ data }) => {
        dispatch({ type: UPDATE_USER_PROFILE, payload: data })
      })
      .catch(err => {
        console.log(err)
        dispatch({ type: UPDATE_USER_PROFILE, payload: err?.response?.data })
      })
  }
}

export function clearUpdateProfileStatus() {
  return dispatch => {
    dispatch({ type: UPDATE_USER_PROFILE, payload: null })
  }
}

export const getDocumentsByTrigger = data => {
  const token = localStorage.getItem('customerkey')
  if (token) {
    axiosConfig.headers.Authorization = 'Bearer ' + token
  } else {
    delete axiosConfig.headers.Authorization
  }
  const requestUrl = `${API_ROOT}/api/embed/documents/trigger`
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id: data.center_id ?? null,
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  return axios.post(requestUrl, data, axiosConfig)
}

export const getFormsByTrigger = data => {
  const token = localStorage.getItem('customerkey')
  if (token) {
    axiosConfig.headers.Authorization = 'Bearer ' + token
  } else {
    delete axiosConfig.headers.Authorization
  }
  const requestUrl = `${API_ROOT}/api/embed/forms/trigger`
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id: data.center_id ?? null,
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  return axios.post(requestUrl, data, axiosConfig)
}

export const submitEmbedFormData = (formIdOrUuid, data) => {
  const token = localStorage.getItem('customerkey')
  if (token) {
    axiosConfig.headers.Authorization = 'Bearer ' + token
  } else {
    delete axiosConfig.headers.Authorization
  }
  const requestUrl = `${API_ROOT}/api/embed/forms/${formIdOrUuid}/submit`
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    center_id: data.center_id ?? null,
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  return axios.post(requestUrl, data, axiosConfig)
}

export const addRelatedContactToSharedMembership = (membershipId, postData) => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  const requestUrl = `${API_ROOT}/api/embed/profile/membership/${membershipId}/related`
  return axios.post(requestUrl, postData, axiosConfig)
}

export const cancelMembership = async membershipId => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    center_id: localStorage.getItem('selected_center_id'),
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/profile/memberships/${membershipId}`
  return axios.delete(requestUrl, axiosConfig)
}

export const cancelMembershipWithReason = async (membershipId, postData) => {
  const centerId = localStorage.getItem('selected_center_id')
  const regionId = localStorage.getItem('region_id')

  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    center_id: centerId,
    region_id: regionId,
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/profile/memberships/${membershipId}`
  return axios.delete(requestUrl, { ...axiosConfig, data: postData })
}

const membershipRequestConfig = () => {
  axiosConfig.headers.Authorization =
    'Bearer ' + localStorage.getItem('customerkey')
  axiosConfig.params = {
    center_id: localStorage.getItem('selected_center_id'),
    region_id: localStorage.getItem('region_id'),
    url_prefix: store.getState().accountreducer.urlPrefix
  }
  return axiosConfig
}

export const pauseMembership = async (membershipId, postData) => {
  const requestUrl = `${API_ROOT}/api/embed/profile/memberships/${membershipId}/pause`
  return axios.post(requestUrl, postData, membershipRequestConfig())
}

export const unpauseMembership = async membershipId => {
  const requestUrl = `${API_ROOT}/api/embed/profile/memberships/${membershipId}/unpause`
  return axios.post(requestUrl, {}, membershipRequestConfig())
}

export const getUserCommunicationPreferences = (email, token) => {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix,
    email,
    token
  }

  const requestUrl = `${API_ROOT}/api/embed/marketing/preferences`
  return axios.get(requestUrl, axiosConfig)
}

export const unsubscribeFromEmails = postData => {
  axiosConfig.params = {
    url_prefix: store.getState().accountreducer.urlPrefix
  }

  const requestUrl = `${API_ROOT}/api/embed/marketing/preferences`
  return axios.post(requestUrl, postData, axiosConfig)
}
